module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_d-28f391b50981695f23d2f05a89c8e8e2.png";